import { css } from '@emotion/react';
import styled from '@emotion/styled';

import useGetServiceStatus from '../model/useGetServiceStatus';

import type { ReactNode } from 'react';
import type { NoticeBannerVariant } from '@/shared/ui/NoticeBanner';

import { NoticeBanner } from '@/shared/ui/NoticeBanner';

/**
 * 서비스 상태 요약 배너.
 * @description
 * - 현재 이상 서비스 유무에 따라 성공/경고 아이콘과 메시지를 표시한다.
 * - 우측에는 마지막으로 데이터를 수신한 시각을 노출한다.
 */
const ServiceStatusBanner = () => {
  const { data, dataUpdatedAt, isError } = useGetServiceStatus();
  const errorCount = data?.currentErrorServiceList?.length ?? 0;
  const { variant, message } = getBannerContent({ errorCount, isError });

  return <NoticeBannerWrapper variant={variant} message={message} dataUpdatedAt={dataUpdatedAt} />;
};

export default ServiceStatusBanner;

const getBannerContent = ({
  errorCount,
  isError,
}: {
  errorCount: number;
  isError: boolean;
}): {
  message: ReactNode;
  variant: NoticeBannerVariant;
} => {
  if (isError) {
    return {
      variant: 'danger',
      message: <span>목록 로딩 중 일시적인 오류가 발생했습니다.</span>,
    };
  }

  if (errorCount > 0) {
    return {
      variant: 'danger',
      message: (
        <span>
          현재, 비정상 상태의 서비스가 <BoldText>{errorCount}개</BoldText> 있습니다.
        </span>
      ),
    };
  }

  return {
    variant: 'success',
    message: <span>카카오클라우드의 모든 서비스가 정상적으로 동작하고 있습니다.</span>,
  };
};

const BoldText = styled('strong')(
  () => css`
    font-weight: 700;
  `,
);

const NoticeBannerWrapper = styled(NoticeBanner)`
  margin: 16px -4px 0 -4px;
`;
